import api from "./Api";

class FiscalSpedContribuicoesService {
  GetJobsOData(payload) {
    return api
      .get("/v1/fiscal/sped/contribuicoes/jobs" + payload)
      .then((response) => response.data);
  }

  PostJob(payload) {
    return api
      .post("/v1/fiscal/sped/contribuicoes/jobs", payload)
      .then((response) => response.data);
  }

  DeleteJob(payload) {
    return api
      .delete("/v1/fiscal/sped/contribuicoes/jobs/" + payload)
      .then((response) => response.data);
  }

  DownloadJob(payload) {
    return api
      .get("/v1/fiscal/sped/contribuicoes/jobs/" + payload + "/download", {
        responseType: "blob",
      })
      .then((response) => response);
  }

  GetFiltros() {
    return api
      .get("/v1/fiscal/sped/contribuicoes/filtros")
      .then((response) => response.data);
  }

  GetConfiguracoes() {
    return api
      .get("/v1/fiscal/sped/contribuicoes/configuracoes")
      .then((response) => response.data);
  }

  PutConfiguracoes(payload) {
    return api
      .put("/v1/fiscal/sped/contribuicoes/configuracoes", payload)
      .then((response) => response.data);
  }

  GetContabilista() {
    return api.get("/v1/fiscal/sped/contabilista").then((response) => {
      return response.data;
    });
  }

  PutContabilista(payload) {
    return api.put("/v1/fiscal/sped/contabilista", payload).then((response) => {
      return response.data;
    });
  }
}

export default new FiscalSpedContribuicoesService();
